import type { MaybeRefOrGetter } from 'vue';
import type { Panel } from '#layers/ui/types/panel';
import { onUnmounted, toValue, watch } from 'vue';
import { usePaneStore } from '#layers/ui/stores/pane';

export interface UsePanelOptions {
	enabled?: MaybeRefOrGetter<boolean>;
}

export const usePanel = (panel: Panel, options: UsePanelOptions = {}) => {
	const { enabled = true } = options;
	const paneStore = usePaneStore();

	const hidePanel = () => {
		// Close the pane if this panel is the one on screen, so a stale
		// persisted `panelVisible` can't collapse the sidebar or auto-reopen it later.
		if (paneStore.currentPanel?.id === panel.id) {
			paneStore.togglePanel({ open: false });
		}

		paneStore.unregisterPanel(panel);
	};

	watch(() => toValue(enabled), (isEnabled) => {
		if (isEnabled) {
			paneStore.registerPanel(panel);
			return;
		}

		hidePanel();
	}, { immediate: true });

	onUnmounted(() => hidePanel());
};
